module.exports = __webpack_public_path__ + "img/bluearw-forward.ca09e8e1.svg";